module.exports = __webpack_public_path__ + "img/close-grey.6c2880ea.svg";